import i18n from '../../../i18n'

export const getExtraServiceName = service => {
  if (!!service.extraName && service.extraName.startsWith('calculation.service')) {
    return `(${i18n.t(service.extraName)})`
  } else if (!!service.extraName) {
    return `(${service.extraName})`
  }
  return ''
}
